import { useRef, useState, useLayoutEffect } from "react";

const ResponsiveWrapper = ({ children, fallbackHeight = 200 }) => {
	const containerRef = useRef(null);
	const [size, setSize] = useState({ width: 0, height: 0 });

	useLayoutEffect(() => {
		const updateSize = () => {
			if (containerRef.current) {
				const { width, height } = containerRef.current.getBoundingClientRect();
				setSize({
					width,
					height: height > 0 ? height : fallbackHeight,
				});
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, [fallbackHeight]);

	return (
		<div
			ref={containerRef}
			style={{
				width: "100%",
				height: "100%",
				minHeight: fallbackHeight,
				position: "relative",
			}}
		>
			{size.width > 0 && size.height > 0 ? children(size) : null}
		</div>
	);
};

export default ResponsiveWrapper;
